import script from "./TopMenuContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopMenuContainer.vue?vue&type=script&setup=true&lang=ts"

import "./TopMenuContainer.vue?vue&type=style&index=0&id=6bda957c&lang=scss"

const __exports__ = script;

export default __exports__